<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8" style="display: flex;"
          ><div class="search-area-div">公司名称</div>
          <el-select
            filterable
            v-model="tenantGuid"
            placeholder="请选择"
            @change="selectCpy(tenantGuid)"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" style="display: flex;">
          <div class="search-area-div">部门名称</div>
          <el-select
            filterable
            v-model="organisationGuid"
            placeholder="请选择"
            @visible-change="showOrg"
            @change="selectOrg"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;" v-if="showMore">
        <el-col :span="15" style="display: flex;">
          <div class="search-area-div">操作时间</div>
          <el-date-picker
            
            size="small"
            v-model="inputTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            >
          </el-date-picker>
        </el-col>
        
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      
      <el-table
        :data="tableData"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          label="序号"
          header-align="center"
          align="center"
          fixed="left"
          width="60"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="评级模型名称"
          header-align="center"
          align="left"
          min-width="150"
        >
          <template slot-scope="scope">{{ scope.row.modelName }}</template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="公司名称"
          header-align="center"
          align="left"
          min-width="240px"
        >
          <template slot-scope="scope">{{
            scope.row.tenantName ||"-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="organisationName"
          label="部门名称"
          header-align="center"
          align="left"
          min-width="150px"
        >
          <template slot-scope="scope">{{
            scope.row.organisationName ||"-"
          }}</template>
        </el-table-column>

        <el-table-column
          prop=" score"
          label="分值"
          header-align="center"
          align="right"
          width="60"
        >
          <template slot-scope="scope">{{
            scope.row.score |scoreFilter
          }}</template>
        </el-table-column>
        <el-table-column
          prop="grade"
          label="评级"
          header-align="center"
          align="left"
          width="60"
        >
          <template slot-scope="scope">{{
            scope.row.grade || "-"
          }}</template>
        </el-table-column>

        <el-table-column
          prop="generateTime"
          label="生成时间"
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{
            scope.row.generateTime | getTimeDate
          }}</template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="操作人"
          header-align="center"
          align="left"
          
          width="96"
        >
          <template slot-scope="scope">{{
            scope.row.staffName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="操作时间"
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{
            scope.row.inputTime | getTimeDate
          }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
          min-width="60"
        >
          <template slot-scope="scope">
            <a class="txt-color" v-if="scope.row.grade" @click="checkScore(scope.row,1)">查看</a>
            <a
              class="txt-color" v-else
              @click="checkScore(scope.row,2)"
              >评分</a
            >
           
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <!-- //! 编辑弹框 -->
    <el-dialog
      :title="textTitle"
      top="5vh"
      custom-class="configure-fields"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <div class="title" style="padding-left: 20px">
          <span></span>模型信息
        </div>
        <el-row>
          <el-col :span="12">
            <!-- 评级模型名称 -->
            <el-form-item>
              <span slot="label">评级模型名称： </span>
              <el-input
                class="fl w240"
                type="input"
                disabled
                v-model="configForm.modelName"
              />
              
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 应用公司 -->
            <el-form-item>
              <span slot="label" style="color: red"> </span>
              <span slot="label">应用公司：</span>
              <el-input
                class="fl w240"
                type="input"
                disabled
                v-model="configForm.tenantName"
              />
                
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 应用部门 -->
            <el-form-item>
              <span slot="label" style="color: red"> </span>
              <span slot="label">应用部门：</span>
              <el-input
                class="fl w240"
                type="input"
                disabled
                v-model="configForm.organisationName"
                
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <div style="display: flex; justify-content: space-between">
          <div class="title" style="padding-left: 20px">
            <span></span>评分信息
          </div>
        </div>
        <div >
        <el-table
          :data="configForm.scoreDetails"
          ref="table"
          :span-method="arraySpanMethod"
          border
          class="detail-class"
          style="width: 90%; margin:auto"
        >
          
          <!-- 指标大类 -->
          <el-table-column
            prop="categoryName"
            label="指标大类"
            
            header-align="left"
            align="left"
            
          >
            <template slot-scope="scope" >
              <div :class="scope.$index==configForm.scoreDetails.length-1?'table-color':''">
                <span >{{ scope.row.categoryName }}</span>
              </div>
                
            </template>
          </el-table-column>
          <!-- 指标大类权重 -->
          <el-table-column
            prop="categoryWeight"
            label="大类权重(%)"
            header-align="left"
            align="right"
            width="110"
          >
            <template slot-scope="scope" >
                <span >{{ scope.row.categoryWeight }}</span>
             
            </template>
          </el-table-column>
          <!-- 指标名称 -->
          <el-table-column
            prop="indicateName"
            label="指标名称"
            header-align="left"
            align="left"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.indicateName }}</span>
            </template>
          </el-table-column>
          <!-- 指标权重 -->
          <el-table-column
            prop="indicateWeight"
            label="指标权重(%)"
            header-align="left"
            align="right"
            width="110"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.indicateWeight }}</span>
            </template>
          </el-table-column>
          <!-- 打分内容 -->
          <el-table-column
            prop="indicateName"
            label="打分内容"
            header-align="left"
            align="left"
            
          >
            <template slot-scope="scope">
              <div v-show="scope.$index<configForm.scoreDetails.length-1">
              
                <el-select
                size="mini"
                class="fl"
                :disabled="!isEdit"
                v-model="scope.row.scoreContent"
                placeholder="请选择"
                @change="selectScore(scope.row)"
              >
                <el-option
                  v-for="item in scope.row.scoreList"
                  :key="item.guid"
                  :label="item.scoreContent"
                  :value="item.scoreContent"
                >
                </el-option>
              </el-select>
              </div>
              <div v-show="scope.$index==configForm.scoreDetails.length-1">
                <span>{{ scope.row.scoreContent }}</span>
              </div>
              
            </template>
          </el-table-column>
          <!-- 指标权重 -->
          <el-table-column
            prop="score"
            label="分值"
            header-align="left"
            align="right"
            width="70"
          >
            <template slot-scope="scope">
              
              <span>{{ scope.row.score }}</span>
            </template>
          </el-table-column>
        </el-table>
          <p  class="tips-class">
            备注：主观的指标由评级人员选择打分内容进行打分；客观指标则系统直接给出内容。
          </p>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain v-if="isEdit" @click="visible = false">取 消</el-button>
        <el-button size="mini" type="info" v-if="isEdit" @click="submit">提 交</el-button>
        <el-button size="mini" type="info" v-else @click="visible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { route } from "@/api/apiRoute";
  import store from "@/store";
  import TabList from "@/components/tab/tabList.vue";
  export default {
    components: {
      TabList,
    },
    data() {
      return {
        tableHeight: window.innerHeight - 240,
        contentMainHeight: window.innerHeight - 220,
        showMore: false, // 筛选项显示更多，默认否
        loading: false,
        visible: false,
        isEdit: false,
        promiseArr:[],
        textTitle: "",
        score:null,
        showGrade: false,
        modelGradeGuid:'',
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
        },
        tenantGuid: "",//公司名称的guid
        organisationGuid: "",//部门名称的guid
        // inputTimeStart:"",//操作开始时间
        // inputTimeEnd:"",//操作结束时间
        inputTime:'',
        tableData: [],
        promiseArr:[],
        configForm: {
          modelName: "", //模型名称
          gradeCycle: "", //评级周期
          bizState: "", //启用状态
          tenant:{},
          tenantName: "", //应用公司
          tenantGuid: "", //应用公司id
          // organisation:{},
          organisationName: "", //应用部门
          organisationGuid: "", //应用部门id
          modelDesc: "", //模型描述
          indicateDetailJson: [], //评级模型指标设置明细
          levelDetailJson: [], //评级模型等级设置明细
        },
        // 应用公司列表
        tenantList: [],
        // 应用部门列表
        departmentList: [],
        //
        tagList: [], //标签指标大类
        // categoryList: [], //评级指标

        
        tabIndex: 0,
      };
    },
    filters: {
      scoreFilter(val) {
        if(val ||val==0){
          return val
        }else {
          return "-"
        }
      },
      
    },
    created() {
      // this.getList();
    },
    mounted() {
      this.search();
      this.getCompany()
    },
    watch: {
      showMore(val, oldVal) {
      if(val) {
        this.tableHeight = window.innerHeight - 290;
        this.contentMainHeight = window.innerHeight - 270;
        return;
      }
      if(!val) {
        this.tableHeight = window.innerHeight - 240;
        this.contentMainHeight = window.innerHeight - 220;
        return;
      }
    },
    },
    // computed:{
    //   score(){
    //     this.configForm.scoreDetails.reduce((p,c)=>{
    //       return p +Number (c.score)*Number (c.indicateWeight)
    //     },0)
    //   }
    // },
    methods: {
      // 获取评分
      search() {
        let that = this;
        that.loading = true;
        that.tableData = [];
        console.log('that.inputTime',that.inputTime);
        
        let req = {
          pageIndex: that.page.pageIndex,
          pageSize: that.page.pageSize,
          tenantGuid: that.tenantGuid,//公司名称的guid
          organisationGuid:that.organisationGuid,//部门名称的guid
          inputTimeStart:that.inputTime.length?that.inputTime[0]:'',//操作开始时间
          inputTimeEnd:that.inputTime.length?that.inputTime[1]:'',//操作结束时间
        };
        console.log('that.inputTime1',req.inputTimeStart);
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/score/page-list`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tableData = res.data.data.records;
              that.page.totalPage = res.data.data.totalPages;
              that.page.totalRows = res.data.data.totalRows;
              that.loading = false;
              console.log("that.tableData", that.tableData);
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 获取应用公司
      getCompany() {
        let that = this;
        let req={
          pageIndex: 1,
          pageSize: -1,
          bizState: "Y"
        }
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants` ,
              req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tenantList = res.data.data.records;
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 选择应用公司获取应用部门
      selectCpy(val) {
        
        let that = this;
        
        that.departmentList = [];
       
        that.organisationGuid = '';
        
        
        
        let req = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: val,//公司唯一标识
          sendTenantGuid: localStorage.guid,
        };
        that.api
          .postJson(
            `/${serverConfig.msPersonnelService}/organisation/data/get`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.departmentList = res.data.data.records;
              that.$forceUpdate();

            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 选择应用部门
      selectOrg(val) {
        
        this.$forceUpdate();
      },
      showOrg(val){
        if(val&&!this.tenantGuid){
          this.$message.error('请先选择应用公司')
        }
      },
      // 清空搜索
      emptySearch() {
        this.tenantGuid= "",//公司名称的guid
        this.organisationGuid= "",//部门名称的guid
        this.inputTime=[],//操作时间
        this.search();
      },
      // 数组去重
      unipFunc(arr) {
        let arr1 = []; //存id
        let newArr = []; //存新数组
        for(let i in arr){
          if(arr1.indexOf(arr[i].gradeCategoryGuid) == -1){
            arr1.push(arr[i].gradeCategoryGuid);
            newArr.push(arr[i]);
          }
        }
        return newArr;
    },
      mapFunc(arr1,arr2){
        let newArr=[]
        
        arr1.forEach((item,idx)=>{
          newArr[idx]=[]
          for(let i in arr2){
            if(item.gradeCategoryGuid==arr2[i].gradeCategoryGuid){
              newArr[idx].push(arr2[i])
              console.log('aaa',newArr);
              
            }
          }
        })
        newArr.forEach((item,index)=>{
          let lg=item.length
          item.forEach(i=>{
            i.idx=lg
          })
        })


        // newArr.forEach(item=>{
        //   newArr2.push(item.length)
        // })
        let arr=newArr.reduce(function (a, b) { 

            return a.concat(b)
        });
        return arr
      },
      // 获取打分内容
      getScore(row){
        let that=this
        
        that.api
        .get(`/${serverConfig.msCustomerService}/data-grade/indicate/detail/${row.indicateGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // row.scoreList = res.data.data.details;
            let dataList=res.data.data
            that.$nextTick(()=>{
                that.$set(row,'scoreList',dataList.details)
                // that.$set(row,'indicateWeight',dataList.indicateWeight)
              that.$forceUpdate(); 

            })
            
            
          } else {
            that.$message.error(res.data.msg);
          }
        });
      },
      // 选择打分内容
      selectScore(row){
        // let scoreDetails=JSON.parse(JSON.stringify(this.configForm.scoreDetails))
        // scoreDetails.pop()
        let score =row.scoreList.filter(item=>{
          return row.scoreContent==item.scoreContent
        })
        row.score=score[0].score

        let list =this.configForm.scoreDetails.filter(item=>{
          // return item.scoreContent &&item.scoreContent!='等级'
          return item.scoreContent &&item.indicateWeight!='等级'
        })
        // 选择打分内容后，获取guid
        let arr =row.scoreList.filter(item=>{
          return row.scoreContent==item.scoreContent
        })
        row.indicateGradeDetailGuid=arr[0].guid
        // console.log('22',score);
        console.log('777',this.configForm.scoreDetails,list);
        // this.scoreTest(this.configForm.scoreDetails)
        
        // let age=this.configForm.scoreDetails.reduce((p,c)=>{
          
        //   if(c.score){
        //     return Number (c.score) * Number (c.indicateWeight)/100 +p
        //   }else{
        //     return p
        //   }

        //   // return c.score?(Number (c.score) * Number (c.indicateWeigh)/100 +p):p
        // },0)
        // this.configForm.score=this.score
        this.scoreTest(list)
        // console.log('9889',age);
        this.$forceUpdate();
      },
      // 评分试算
      scoreTest(list){
        let that=this
        // let scoreDetails=JSON.parse(JSON.stringify(this.configForm.scoreDetails))
        // scoreDetails.pop()
        let req={
          modelGradeGuid:that.modelGradeGuid,
          // scoreDetails:scoreDetails,
          scoreDetails:list
        }
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/score/test`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let tableData2 = res.data.data;
              that.configForm.score=tableData2.score
              that.configForm.grade=tableData2.grade
            
              let length=that.configForm.scoreDetails.length-1
              that.configForm.scoreDetails[length].scoreContent=tableData2.grade
              that.configForm.scoreDetails[length].categoryWeight=tableData2.score
              
              console.log("tableData2", tableData2,that.configForm.scoreDetails[length]);
              this.$forceUpdate();
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 获取评分详情
      checkScore(row,flag) {
        let that = this;
        that.modelGradeGuid=row.modelGradeGuid
        // flag=1查看，flag=2评分
        if(flag==1){
          that.isEdit = false;
          that.textTitle = "查看";
          that.visible = true;
        }else{
          that.isEdit = true;
          that.textTitle = "评分";
          
        }
        
        // this.currentIndex = '';
        
        that.api
          .get(
            `/${serverConfig.msCustomerService}/data-grade/score/detail/${row.guid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.configForm = res.data.data;
              console.log('configForm',that.configForm);
              // 整理表格数据
              if(that.configForm.scoreDetails && that.configForm.scoreDetails.length>0){
                let newArr=that.unipFunc(that.configForm.scoreDetails)
              console.log('newArr',newArr);
              let newArr2=that.mapFunc(newArr,that.configForm.scoreDetails)
              console.log('newArr2',newArr2);
              that.configForm.scoreDetails=newArr2

              if(flag==2){
                
                that.configForm.scoreDetails.forEach(item=>{
                  that.promiseArr.push(that.getScore(item))
                  
                })
              }
              }
              
              // that.scoreDetails=res.data.data.scoreDetails
              // var row =that.$refs.table.insertRow(res.data.data.scoreDetails.length)
              // var cell1 = row.insertCell(0);
              // var cell2 = row.insertCell(1);
              // cell1.innerHTML = "NEW CELL1";
              // cell2.innerHTML = "NEW CELL2";
              const row={
                categoryName:'总分数',
                categoryWeight:that.configForm.score,
                indicateWeight:'等级',
                scoreContent:that.configForm.grade,

              }
              if(that.configForm.scoreDetails&&that.configForm.scoreDetails.length>0){
                that.configForm.scoreDetails.push(row)
              }
              
              Promise.all(that.promiseArr).then(
                that.visible=true)
              .catch(e => console.log(e));

              console.log('99',that.configForm.scoreDetails);
              
              // that.$refs.table[0].store.states.data.unshift(row)
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex  === this.configForm.scoreDetails.length-1) {
          if (columnIndex === 1 ||columnIndex === 4) {
            return [1, 2];
          } else if(columnIndex === 2 ||columnIndex === 4){
            return [0,0]
          }
        }
      },
      // 提交评分
      submit(){
        let that=this
        let userInfo=JSON.parse(localStorage.userInfo)
        let scoreDetails=JSON.parse(JSON.stringify(this.configForm.scoreDetails))
        scoreDetails.pop()
        let flag=false
        scoreDetails.forEach(item=>{
          if(!item.scoreContent){
            flag=true
            
          }
        })
        if(flag){
          that.$message.error('打分内容不能为空')
            return
        }
        console.log('111scoreDetails',that.configForm.scoreDetails,scoreDetails);
        // return
          let req={
            guid:that.configForm.guid,
            score:that.configForm.score,
            grade:that.configForm.grade,
            staffGuid:userInfo.staffGuid,
            staffName:userInfo.staffName,
            scoreDetails:scoreDetails
          }
          that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/score/submit`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('提交成功！');
              that.visible=false
              that.search()
            } else {
              that.$message.error(res.data.msg);
            }
          });
        
        
      },
     
      // 分页
      handleSizeChange(val) {
        let that = this;
        that.page.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.page.pageIndex = val;
        this.search();
      },
    },
  };
</script>
<style lang="less" scoped>

.tips-class{
  width: 90%;
  margin: 10px auto;
  color: #4fa1a4;
  text-align: left;
  font-size: 12px;
}
  .el-table /deep/ .el-input__inner {
    height: 30px;
    line-height: 40px;
  }

  .el-range-editor.el-input__inner {
    padding: 0px;
  }

  /deep/ .el-checkbox__label {
    display: none;
  }
  /deep/ .configure-fields {
    width: 800px !important;
  }
  /deep/ .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }

  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }

  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }

  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }

  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }

  // .content {
  //   background: #fff;
  //   font-size: 18px;
  // }

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .title span {
    width: 6px;
    height: 14px;
    background: #4fa1a4;
    display: inline-block;
    margin-right: 10px;
  }

  .base {
    background: #fff;
    padding: 10px 0;
  }

  .content h1 {
    margin: 4px 0px;
  }

  .base-content {
    display: flex;
    font-size: 15px;
    padding: 7px 0;
  }

  .base-content .base-info {
    display: flex;
    align-items: center;
    padding: 0 40px;
  }

  .base-content .base-info .base-title {
    word-break: keep-all;
  }

  .button-area {
    display: flex;
    justify-content: space-between;
    padding: 0px 20px 10px 0px;
    margin-top: 0;
  }

  /deep/.el-checkbox__label {
    display: block;
  }

  .checkbox-show {
    display: flex;
    margin-bottom: 10px;
  }
  .field-show {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px;
  }

  .product {
    display: flex;
    align-items: center;
  }

  .product-img {
    width: 60px;
    height: 40px;
    margin-right: 15px;
  }

  .product-text {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-col-5 {
    width: 33%;
  }

  .ipt-sty {
    width: 69% !important;
  }
  .add-btn {
    width: 80%;
    height: 28px;
    line-height: 28px;
    margin-top: 8px;
    padding: 0;
  }
  .flex {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
  .flex1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .checkTag {
    background-color: rgb(242, 242, 242);
  }
  .btn {
    display: none;
  }
  .btn a {
    cursor: pointer;
  }
  .el-table__body tr:hover .btn {
    display: block;
  }

  /deep/.el-tree-node__label {
    width: 80%;
    white-space: normal;
    overflow: hidden;
    text-align: left;
  }

  .el-tree-node__content {
    height: auto;
  }

  .radio-ora {
    margin-right: 12px;
  }

  .staff-type {
    display: inline-block;
    width: 72px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-type-biz {
    display: inline-block;
    width: 52px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-wrap {
    color: #d8814b;
    background: rgba(255, 238, 224, 0.39);
  }

  .biz-state {
    display: inline-block;
    width: 48px;
    height: 21px;
    line-height: 21px;
    background: rgba(239, 239, 239, 0.38);
    border-radius: 11px;
    margin-left: 5px;
  }

  .select-node {
    margin: 0 0 17px 0;
    text-align: left;
    font-size: 18px;
    color: #323233;
  }

  .custom-tree-node {
    display: inline-flex;
    overflow: hidden;
  }

  .content-main-box {
    overflow-y: visible;
  }

  .search-area{
    margin-bottom: 0;
  }
  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px
  }
  .ipt-sty{
    flex: 1;
  }
  .el-col-6{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-12{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-8{
    display: flex;
    // margin-bottom: 15px;
    justify-content: flex-start;
  }
  /* .el-pagination {
    width: calc(100% - 260px - 231px);
  } */
</style>
